/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_FestnetzInputs */

const de__field_festnetz = /** @type {(inputs: _Field_FestnetzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Festnetz`)
};

/**

* @param {_Field_FestnetzInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_festnetz = /** @type {((inputs?: _Field_FestnetzInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_FestnetzInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_festnetz(inputs)
});